import config from './config';
import { getLocalStorage, setLocalStorage } from './func';
import { appLocalStorage } from './storage';
import changeLanguageInOrder from './changeLanguageInOrder';
import { claimGuestAuth, safeAuthReturn } from '../guestTrial/store';
import { requestAccountOnboarding } from '../onboarding/state';

export function signInLanguage(value) {
  const language = typeof value === 'string' ? value.toLowerCase().split(/[-_]/)[0] : '';
  return language && (language === 'en' || config.languages.includes(language)) ? language : 'en';
}

export default async function finishSignIn(data, { i18n, navigate, isCurrent }) {
  if (!data?.user || typeof data.user !== 'object' || Array.isArray(data.user)
    || typeof data.token !== 'string' || !data.token.trim()) {
    throw new Error(data?.message || 'Sign-in failed');
  }

  // A feed request must start with its final viewer/language context.
  const language = signInLanguage(data.user.lng_code);
  await changeLanguageInOrder(i18n, language, isCurrent);
  if (!isCurrent()) return undefined;

  // Commit both values together, after all asynchronous work. If browser storage
  // refuses a write, retain the previous session rather than a token/user mismatch.
  const previous = [config.token, config.user].map(key => [key, getLocalStorage(key)]);
  try {
    setLocalStorage(config.token, data.token);
    setLocalStorage(config.user, JSON.stringify(data.user));
  } catch (error) {
    previous.forEach(([key, value]) => {
      try {
        if (value === null) appLocalStorage.removeItem(key);
        else setLocalStorage(key, value);
      } catch { /* Storage may remain unavailable; preserve the original error. */ }
    });
    throw error;
  }
  const from = safeAuthReturn(new URLSearchParams(window.location.search).get('from') || getLocalStorage('login_from') || '/');
  claimGuestAuth(from, data.user.id);
  try { appLocalStorage.removeItem('login_from'); } catch { /* The session is installed; navigation can continue. */ }
  if (data.is_new_user === true && requestAccountOnboarding(data.user.id, from)) {
    navigate(language === 'en' ? '/' : `/${language}/`, { replace: true,
      state: { onboardingAccount: String(data.user.id) } });
  } else navigate(from);
  return data;
}
